import {
  FlexColumn,
  ModelSelect,
  ModelTextarea,
} from '@equifinance/shared';
import styled from 'styled-components';
import {
  Label, SelectWrapper, UnderwriterDecisionForm, UnderwriterDecisionTitle,
} from '../../../../components/UnderwriterDecision';
import { ValuationDecision } from '../../../../../../contexts/checklist';

const UnderwriterDecisionHeader = styled(UnderwriterDecisionTitle)`${({ theme }) => `
  border-radius: ${theme.borderRadius[2]} ${theme.borderRadius[2]} 0 0;
`}`;

const UnderwriterDecisionBody = styled(UnderwriterDecisionForm)`${({ theme }) => `
  border-radius: 0 0 ${theme.borderRadius[2]} ${theme.borderRadius[2]};
`}`;

export default function ValuationUnderwriterDecision() {
  return (
    <FlexColumn>
      <UnderwriterDecisionHeader>
        <Label>{'Underwriter\'s decision'}</Label>
        <SelectWrapper>
          <SelectWrapper>
            <ModelSelect
              placeholder="Please select"
              field="valuation.decision"
              options={ValuationDecision}
            />
          </SelectWrapper>
        </SelectWrapper>
      </UnderwriterDecisionHeader>
      <UnderwriterDecisionBody>
        <ModelTextarea
          field="valuation.justification"
          label="Justification"
          required
          rows={3}
        />
      </UnderwriterDecisionBody>
    </FlexColumn>
  );
}
